export default "__VITE_ASSET__Cpj63hUB__"